import { render, staticRenderFns } from "./ToolSection.vue?vue&type=template&id=623b48b1&scoped=true&"
import script from "./ToolSection.vue?vue&type=script&lang=js&"
export * from "./ToolSection.vue?vue&type=script&lang=js&"
import style0 from "./ToolSection.vue?vue&type=style&index=0&id=623b48b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b48b1",
  null
  
)

export default component.exports